import Navigation from "../../header";
import { Container } from "@mui/material";
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, models } from 'powerbi-client';
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const MaterialReport = () => {
	var userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportMaterial}>
					<h1 className="report-header">Customer Material Report</h1>
					{/* <iframe role="presentation" width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=2f16c5f1-4fe3-42c3-94f3-db40324bca38&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi" frameBorder="1"></iframe> */}
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=2f16c5f1-4fe3-42c3-94f3-db40324bca38&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default MaterialReport;